import {
  LoggerFactory,
  LogLevel,
  ConsoleTransport,
} from '@significo/pulse';
import {LOG_LEVEL} from '@/ts/utils/consts';
import {persistentStorage} from '@/ts/instances/persistant-storage';
import {parseLogLevel} from '@/ts/utils/log-level-parser';

function resolveLogLevel(value: LogLevel | string): LogLevel {
  if (typeof value === 'number') {
    return value;
  }
  return parseLogLevel(value) ?? LogLevel.Trace;
}

const logLevel: LogLevel = persistentStorage.logLevel ?? resolveLogLevel(LOG_LEVEL);
/** Singleton LoggerFactory instance configured from persistent storage or the default log level. */
export const loggerInstance = new LoggerFactory({level: logLevel, transports: [new ConsoleTransport()]});
